import { createRouter, createWebHistory } from 'vue-router';
import store from '../store/index';
import paths from './paths';
import { getAuthRedirect } from './authGuard';
import qs from 'qs';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

const router = createRouter({
  base: '/',
  history: createWebHistory('/'),
  linkActiveClass: 'active',
  routes: paths,
  parseQuery(query) {
    return qs.parse(query);
  },
  stringifyQuery(query) {
    return qs.stringify(query);
  },
});
// router gards
router.beforeEach(to => {
  NProgress.start();

  const redirect = getAuthRedirect(to, store.getters['auth/isLoggedIn']);
  if (redirect) {
    return redirect;
  }
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
